// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Gamepad = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 24'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <path
        stroke={stroke}
        fill={fill || 'none'}
        d='M37.4.5c-4.9-.1-9.9,2.3-13.7,2.3S14.9.4,10,.5C5.2.6.4,14.8.5,17.2c0,2.3,1.5,4.2,3,5.2s8.5-4.5,13.1-4.4c4.6,0,7.2.2,7.2.2,0,0,2.6-.1,7.2-.2,4.6,0,11.6,5.4,13.1,4.4s2.9-2.8,3-5.2S42.2.6,37.4.5Z'
      />
      <path
        stroke={stroke}
        fill='none'
        d='M16.2,8.8h-2.7v-2.7c0-.7-.6-1.3-1.3-1.3h-.3c-.7,0-1.3.6-1.3,1.3v2.7h-2.7c-.7,0-1.3.6-1.3,1.3v.3c0,.7.6,1.3,1.3,1.3h2.7v2.7c0,.7.6,1.3,1.3,1.3h.3c.7,0,1.3-.6,1.3-1.3v-2.7h2.7c.7,0,1.3-.6,1.3-1.3v-.3c0-.7-.6-1.3-1.3-1.3Z'
      />
      <circle stroke={stroke} fill='none' cx='35.4' cy='6.2' r='1.4' />
      <circle stroke={stroke} fill='none' cx='35.4' cy='14.2' r='1.4' />
      <circle stroke={stroke} fill='none' cx='39.4' cy='10.2' r='1.4' />
      <circle stroke={stroke} fill='none' cx='31.4' cy='10.2' r='1.4' />
    </svg>
  );
};
